import Banner from "./whoweare/Banner";
// import Clients from "./whoweare/Clients";
import Content from "./whoweare/Content";
import { motion } from "framer-motion";

export default function WhoWeAre() {
  return (
    <div className="whoweare-wrapper section">
      <div className="whoweare container">
        <motion.div
          className="whoweare-main flex"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.2 }}
        >
          <Banner />
          <Content />
        </motion.div>
        {/* <Clients /> */}
      </div>
    </div>
  );
}
